// extracted by mini-css-extract-plugin
module.exports = {"Attributes":"Attributes_Attributes__2-Cu-","Attribute":"Attributes_Attribute__12ebO"};